var _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1167,
    height: 1,
    viewBox: "0 0 1167 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 0.5,
    x2: 1167,
    y2: 0.499898,
    stroke: "url(#paint0_linear_1_178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_178",
    x1: 5.5,
    y1: -3.15039,
    x2: 1167,
    y2: 1.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101315",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509556,
    stopColor: "#10AAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101315",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLine);
export default __webpack_public_path__ + "static/media/footer-line.6aecf82492ccfec441fc8bc95b9b3c49.svg";
export { ForwardRef as ReactComponent };